import { render, staticRenderFns } from "./AdminRemoteCard.vue?vue&type=template&id=22180212&scoped=true&"
import script from "./AdminRemoteCard.vue?vue&type=script&lang=js&"
export * from "./AdminRemoteCard.vue?vue&type=script&lang=js&"
import style0 from "./AdminRemoteCard.vue?vue&type=style&index=0&id=22180212&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22180212",
  null
  
)

export default component.exports